








import Vue from 'vue'

import FileManger from '../utils/FileManager'
import types from '../store/types'

export default Vue.extend({
  methods: {
    selectFile(e: Event) {
      this.$store.commit(types.mutations.APP_LOADING_TEXT, '選択したファイルを読み込んでいます')
      this.$store.commit(types.mutations.APP_LOADING, true)

      const manager = new FileManger()
      manager.select(e)
        .then((e: FileReader | null) => {
          this.$store.commit(types.mutations.APP_LOADING, false)

          this.$emit('select', e)
        })
        .catch((e) => {
          window.alert(e)
          console.log(e)

          this.$store.commit(types.mutations.APP_LOADING, false)
        })
    }
  }
})
